export const Products = [
  // {
  //   id: 1,
  //   name: "Digital Watch",
  //   description: [
  //     { support: "Lifetime warranty" },
  //     { support: "free delivery" },
  //     { support: "original" },
  //   ],
  //   price: 120,
  //   offPrice: 120,
  //   discount: 0,
  //   image: "https://s4.uupload.ir/files/1_9nsc.jpg",
  // },
  {
    id: 2,
    name: "Skmei watch",
    description: [{ support: "Lifetime warranty" }, { support: "original" }],
    price: 110,
    offPrice: 100,
    discount: 8,
    image: "https://s6.uupload.ir/files/w1_fx5.png",
  },
  {
    id: 3,
    name: "shaw Watch",
    description: [
      { support: "Lifetime warranty" },
      { support: "original" },
      { support: "free delivery" },
    ],
    price: 199,
    offPrice: 189,
    discount: 10,
    image: "https://s6.uupload.ir/files/w2_u86n.png",
  },
  {
    id: 4,
    name: "Renus Watch",
    description: [
      { support: "Lifetime warranty" },
      { support: "original" },
      { support: "free delivery" },
    ],
    price: 260,
    offPrice: 220,
    discount: 15,
    image: "https://s6.uupload.ir/files/w3_c95a.png",
  },

  {
    id: 5,
    name: "Maimo-WT2105",
    description: [
      { support: "Lifetime warranty" },
      { support: "original" },
      { support: "free delivery" },
    ],
    price: 400,
    offPrice: 380,
    discount: 18,
    image:
      "https://dkstatics-public.digikala.com/digikala-products/71d6ec4081b73007e5b4e94ff65cccf6e4c43eb7_1634819691.jpg?x-oss-process=image/resize,m_lfit,h_600,w_600/quality,q_80",
  },
  {
    id: 6,
    name: "mi watch lite",
    description: [
      { support: "Lifetime warranty" },
      { support: "original" },
      { support: "free delivery" },
    ],
    price: 820,
    offPrice: 800,
    discount: 13,
    image:
      "https://dkstatics-public.digikala.com/digikala-products/3ed2847e22fcc9157391b47fd2725cfc986c03f4_1609323682.jpg?x-oss-process=image/resize,m_lfit,h_600,w_600/quality,q_80",
  },
  {
    id: 7,
    name: "Apple Watch",
    description: [
      { support: "Lifetime warranty" },
      { support: "original" },
      { support: "free delivery" },
    ],
    price: 1000,
    offPrice: 990,
    discount: 13,
    image:
      "https://dkstatics-public.digikala.com/digikala-products/7a37663cc6d905083c4dd181cc10f59d88693eed_1633854492.jpg?x-oss-process=image/resize,m_lfit,h_600,w_600/quality,q_80",
  },
  {
    id: 8,
    name: "Solar",
    description: [
      { support: "Lifetime warranty" },
      { support: "original" },
      { support: "free delivery" },
    ],
    price: 620,
    offPrice: 615,
    discount: 13,
    image:
      "https://dkstatics-public.digikala.com/digikala-products/121856543.jpg?x-oss-process=image/resize,m_lfit,h_600,w_600/quality,q_80",
  },
  {
    id: 9,
    name: "Galaxy Watch",
    description: [
      { support: "Lifetime warranty" },
      { support: "original" },
      { support: "free delivery" },
    ],
    price: 2020,
    offPrice: 2000,
    discount: 13,
    image:
      "https://dkstatics-public.digikala.com/digikala-products/112556303.jpg?x-oss-process=image/resize,m_lfit,h_600,w_600/quality,q_80",
  },
];
